import {
  FETCH_QUOTA,
  FETCH_QUOTA_SUCCESS,
  FETCH_QUOTA_ERROR,
  LOAD_MORE_QUOTA,
  LOAD_MORE_QUOTA_SUCCESS,
  LOAD_MORE_QUOTA_ERROR,
  ADD_QUOTA,
  ADD_QUOTA_SUCCESS,
  ADD_QUOTA_ERROR,
  RESET_ADD_QUOTA,
} from "constants/ActionTypes";

export const fetchQuota = (params) => {
  return {
    type: FETCH_QUOTA,
    params,
  }
};

export const fetchQuotaSuccess = (quotaList) => {
  return {
    type: FETCH_QUOTA_SUCCESS,
    payload: quotaList,
  }
};

export const fetchQuotaError = (error) => {
  return {
    type: FETCH_QUOTA_ERROR,
    payload: error
  }
};

export const loadMoreQuota = (params) => {
  return {
    type: LOAD_MORE_QUOTA,
    params,
  }
};

export const loadMoreQuotaSuccess = (quotaList) => {
  return {
    type: LOAD_MORE_QUOTA_SUCCESS,
    payload: quotaList,
  }
};

export const loadMoreQuotaError = (error) => {
  return {
    type: LOAD_MORE_QUOTA_ERROR,
    payload: error
  }
};


export const addQuota = (payload) => {
  return {
    type: ADD_QUOTA,
    payload,
  }
};

export const addQuotaSuccess = (payload) => {
  return {
    type: ADD_QUOTA_SUCCESS,
    payload,
  }
};

export const addQuotaError = (error) => {
  return {
    type: ADD_QUOTA_ERROR,
    payload: error
  }
};

export const resetAddQuota = () => {
  return {
    type: RESET_ADD_QUOTA,
  }
};
